import {getB2bProxyAccessToken} from "@/services/b2bProxySession";

export function getCookieValue(name){
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
}
// The proxy token: the one of the B2B session when there is one (B2B iframe, set by /b2b/authenticate),
// otherwise the one the skin saved in its cookies. The B2B one first: a skin cookie on the same domain
// belongs to someone else.
export function getProxyAccessToken(){
    return getB2bProxyAccessToken() || getCookieValue("accessToken") || getPersistedUserAccessToken();
}

// Skin Nuxt 3 (es. cinco888): pinia-plugin-persistedstate salva lo store `user`
// come JSON url-encoded nel cookie `user`, con il token in `accessTokenLogin`.
function getPersistedUserAccessToken(){
    const raw = getCookieValue("user");
    if (!raw) return '';
    try {
        return JSON.parse(decodeURIComponent(raw))?.accessTokenLogin || '';
    } catch {
        return '';
    }
}
